import React from 'react'
import { DataTable } from '@ztechapps/webui.data-tools'
import { ListHeader } from './ListHeader'
import { ListRow } from './ListRow'
import { useGridViewContext } from './Context'

export const Layout = () => {
  const { listResult, productListFieldConfig } = useGridViewContext()
  return (
    <DataTable
      tableOptions={{ style: { width: '100%' } }}
      height={'100vh'}
      name={'product-list-view-v2'}
      fields={productListFieldConfig}
      listResult={listResult}
      head={ListHeader}
      row={ListRow}
      stats="products"
    />
  )
}
